module.exports = __webpack_public_path__ + "img/vard3.7a7df8a2.png";